var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.538 13.365A2.537 2.537 0 0 0 3.5 15.402v4.026C3.5 20.848 4.694 22 6.167 22h11.666c1.473 0 2.667-1.151 2.667-2.572v-7.356c0-1.003-.595-1.872-1.464-2.296m-14.498 3.59a2.718 2.718 0 0 1 1.629-.536h4.483a2 2 0 0 0 1.562-.75l1.465-1.83a2 2 0 0 1 1.561-.75h2.595c.433 0 .842.1 1.203.276m-14.498 3.59V2h14.498v7.776M7.538 8.5h4.112v-4H7.538v4Zm0 0v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressKit);
export default __webpack_public_path__ + "static/media/press_kit.7cb496cc4863a4a9e4c18fef7389c768.svg";
export { ForwardRef as ReactComponent };